import React, {
  useRef,
  useImperativeHandle,
  useContext,
  useState,
  useEffect,
} from 'react';
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import { useSelector, useDispatch } from 'dva';
import { Context } from '../../index';
import TitleML from '../TitleML/TitleML';
import DateRangePickerML from '@/components/DateRangePickerML';
export default React.forwardRef(
  // eslint-disable-next-line no-unused-vars
  ({ onSubmitSuccess, queryType = null, formatMessage }, fref) => {
    const dispatch = useDispatch();
    const { control, handleSubmit, setValue, getValues, errors } = useForm();

    const { stepOneData } = useSelector((state) => state.couponsSetting);
    const [isSend, setIsSend] = useState(false);
    const [isExpire, setExpireCoupon] = useState(false);
    const { ref } = useContext(Context);
    const submitRefFour = useRef();
    const clickInput = () => {
      submitRefFour.current.click();
    };
    useImperativeHandle(ref, () => ({
      // handleSubmit 就是暴露给父组件的方法
      clickInput: clickInput,
    }));

    useEffect(() => {
      setValue('templateId', stepOneData.templateId);
      setValue('goodsName', stepOneData.goodsName);
      setValue('channelType', stepOneData.channelType === 2);
      setValue('isSend', stepOneData.isSend);
      setIsSend(stepOneData.isSend);
      setValue('isSendDate', {
        startDate: stepOneData.sendStartDate,
        endDate: stepOneData.sendEndDate,
      });
      setValue('isExpire', stepOneData.isExpire);
      setExpireCoupon(stepOneData.isExpire);
      setValue('expireCouponDate', {
        startDate: stepOneData.expireStartDate,
        endDate: stepOneData.expireEndDate,
      });
    }, [
      setValue,
      stepOneData.templateId,
      stepOneData.goodsName,
      stepOneData.channelType,
      stepOneData.isSend,
      stepOneData.sendStartDate,
      stepOneData.sendEndDate,
      stepOneData.isExpire,
      stepOneData.expireStartDate,
      stepOneData.expireEndDate,
    ]);
    return (
      <Box className="step-form-wrap">
        <form onSubmit={handleSubmit(onSubmitSuccess)}>
          <Box display="flex">
            {/*内容*/}
            <Box pl={7}>
              <TitleML title="通知设置" fontSize="19px" />
              <div
                style={{
                  fontSize: '16px',
                  lineHeight: '22px',
                  color: '#212121',
                  marginTop: '12px',
                  fontWeight: 400,
                }}
              >
                小程序订阅消息
              </div>
              <Box>
                <Box mt={3} className="checkbox-radio-disabled-color">
                  <Controller
                    render={(pr) => (
                      <FormControlLabel
                        variant="standard"
                        checked={isSend ?? false}
                        control={<Checkbox color="primary" />}
                        label={<Box color="#000">开启优惠券领取提醒</Box>}
                        onChange={(e) => {
                          setIsSend(e.target.checked);
                          dispatch({
                            type: 'couponsSetting/resetForm',
                            payload: {
                              value: {
                                stepOneData: {
                                  isSend: e.target.checked,
                                },
                                key: 'stepOneData',
                                step: 3,
                              },
                            },
                          });
                          return pr.onChange(e.target.checked);
                        }}
                        disabled={queryType === 'detail'}
                      />
                    )}
                    control={control}
                    name="isSend"
                  />
                  <Box width="100%" marginTop="11px" paddingLeft="30px">
                    <Box
                      sx={{
                        color: 'rgba(0,0,0,0.87)',
                        fontSize: '16px',
                        lineHeight: '22px',
                        marginBottom: '9px',
                      }}
                    >
                      配置开启时间
                    </Box>
                    <Box>
                      <FormControl variant="standard">
                        <Controller
                          render={(rp) => (
                            <DateRangePickerML
                              label="开始时间"
                              title="结束时间"
                              startText="开始时间"
                              endText="结束时间"
                              defaultStartDate={stepOneData.sendStartDate}
                              defaultEndDate={stepOneData.sendEndDate}
                              rp={rp}
                              setValue={setValue}
                              name="custom-form-submit-name"
                              disabled={queryType === 'detail'}
                              onChange={(e) => {
                                dispatch({
                                  type: 'couponsSetting/resetForm',
                                  payload: {
                                    value: {
                                      stepOneData: {
                                        sendStartDate: e.startDate,
                                        sendEndDate: e.endDate,
                                      },
                                      key: 'stepOneData',
                                      step: 3,
                                    },
                                  },
                                });
                              }}
                            />
                          )}
                          name="isSendDate"
                          control={control}
                          rules={{
                            validate: () => {
                              const status = !(
                                getValues('isSend') &&
                                getValues('isSendDate').startDate === null &&
                                getValues('isSendDate').endDate === null
                              );
                              return status;
                            },
                          }}
                        />
                      </FormControl>
                    </Box>
                    {errors.isSendDate && (
                      <Box mt={1}>
                        <Box className="input-error-style">日期不得为空</Box>
                      </Box>
                    )}
                  </Box>
                </Box>
                <Box mt={3} className="checkbox-radio-disabled-color">
                  <Controller
                    render={(pr) => (
                      <FormControlLabel
                        variant="standard"
                        checked={isExpire ?? false}
                        control={<Checkbox color="primary" />}
                        label={<Box color="#000">开启优惠券到期提醒</Box>}
                        onChange={(e) => {
                          setExpireCoupon(e.target.checked);
                          dispatch({
                            type: 'couponsSetting/resetForm',
                            payload: {
                              value: {
                                stepOneData: {
                                  isExpire: e.target.checked,
                                },
                                key: 'stepOneData',
                                step: 3,
                              },
                            },
                          });
                          return pr.onChange(e.target.checked);
                        }}
                        disabled={queryType === 'detail'}
                      />
                    )}
                    control={control}
                    name="isExpire"
                  />
                  <Box width="100%" marginTop="11px" paddingLeft="30px">
                    <Box
                      sx={{
                        color: 'rgba(0,0,0,0.87)',
                        fontSize: '16px',
                        lineHeight: '22px',
                        marginBottom: '9px',
                      }}
                    >
                      配置开启时间
                    </Box>
                    <Box>
                      <FormControl variant="standard">
                        <Controller
                          render={(rp) => (
                            <DateRangePickerML
                              label="开始时间"
                              title="结束时间"
                              startText="开始时间"
                              endText="结束时间"
                              defaultStartDate={stepOneData.expireStartDate}
                              defaultEndDate={stepOneData.expireEndDate}
                              rp={rp}
                              setValue={setValue}
                              name="custom-form-submit-name"
                              disabled={queryType === 'detail'}
                              onChange={(e) => {
                                dispatch({
                                  type: 'couponsSetting/resetForm',
                                  payload: {
                                    value: {
                                      stepOneData: {
                                        expireStartDate: e.startDate,
                                        expireEndDate: e.endDate,
                                      },
                                      key: 'stepOneData',
                                      step: 3,
                                    },
                                  },
                                });
                              }}
                            />
                          )}
                          name="expireCouponDate"
                          control={control}
                          rules={{
                            validate: () => {
                              const status = !(
                                getValues('isExpire') &&
                                getValues('expireCouponDate').startDate ===
                                  null &&
                                getValues('expireCouponDate').endDate === null
                              );
                              return status;
                            },
                          }}
                        />
                      </FormControl>
                    </Box>
                    {errors.expireCouponDate && (
                      <Box mt={1}>
                        <Box className="input-error-style">日期不得为空</Box>
                      </Box>
                    )}
                  </Box>
                </Box>
                <Box width="100%" maxWidth="333px" mt={5}></Box>
              </Box>
            </Box>
          </Box>
          <Button
            type="submit"
            ref={submitRefFour}
            style={{ display: 'none' }}
          />
        </form>
      </Box>
    );
  },
);
